import { parse } from 'querystring';
import React from 'react';
import { getRouteId } from '@catalogo/shell-web/src/helpers/routeid';
import Seo from '@catalogo/core-seo';
import { RenderComponentProps } from './types';

const RenderComponent: React.FC<RenderComponentProps> = ({
  Component,
  history,
  location,
  ...rest
}): React.ReactElement => {
  const routeId = getRouteId({ location });
  const search = history?.location?.search || '';
  const parsedQs = parse(search.replace('?', ''));
  return (
    <>
      <Seo history={history} />
      <Component {...rest} history={history} location={location} routeId={routeId} parsedQs={parsedQs} />
    </>
  );
};

export default RenderComponent;
